import { useState } from "react";
import emailjs from "emailjs-com";

export function useFormControl(stateInisial) {
  const [dataUser, setDataUser] = useState(stateInisial);
  const [errorForm, saveError] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [sended, setSendedEmail] = useState("");

  const handleChange = (e) => {
    setDataUser({
      ...dataUser,
      [e.target.name]: e.target.value,
    });
  };
  const { user_name, user_email, user_subject, message } = dataUser;
  function handleSubmit(e) {
    e.preventDefault();
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(user_email)) {
      saveError("You must enter a valid email! ");
      setTimeout(() => {
        return saveError("");
      }, 4000);
    } else if (
      user_name.trim() === "" ||
      user_email.trim() === "" ||
      user_subject.trim() === "" ||
      message.trim() === ""
    ) {
      saveError("All the fields are required!");
      setTimeout(() => {
        return saveError("");
      }, 4000);
    } else {
      setSpinner(true);
      setTimeout(() => {
        setSpinner(false);
      }, 1200);
      const emailjssend = emailjs
        .sendForm(
          "sterki_id",
          "sterki_id_1987",
          e.target,
          "dFljW6mf_1BJbbJ6A"
        )
        .then((res) => {
          if (res) {
            setSendedEmail("Email sended Successfully");
            setTimeout(() => {
              return setSendedEmail("");
            }, 3000);
          }
        })
        .catch((error) => {
          console.log("Email not sended!", error);
          saveError("Email not sended Error with the server provider");
          setTimeout(() => {
            return saveError("");
          }, 3000);
        });

      Promise.all([emailjssend]);
    }
  }

  return {
    handleChange,
    handleSubmit,
    errorForm,
    dataUser,
    spinner,
    sended,
  };
}
